import axios from '../utils/axios';

export default function getCreditListing(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/credit-listing', { params })
    )
}